import React, { Component } from 'react'
import { injectIntl, FormattedMessage, InjectedIntlProps } from 'react-intl'
import { autobind } from 'core-decorators'
import { Modal } from 'react-bootstrap'
import GenevaButton from '../../../shared/components/GenevaButton'

require('./styles.scss')

interface IScreenshotDialogProps extends InjectedIntlProps {
  handleClose: Function,
  handleConfirm: Function,
  imageURL: string
}

interface IState {
  text: string
}

class ScreenshotDialog extends Component <IScreenshotDialogProps> {
  state: IState

  constructor(props) {
    super(props)
    this.state = {
      text: props.text || ''
    }
  }

  componentDidMount(){
    document.addEventListener('keyup', (e) => {
        if (e.keyCode === 27) this.props.handleClose()
    });
  }

  @autobind
  closeModal() {
    this.props.handleClose()
  }

  @autobind
  confirmModal() {
    this.props.handleConfirm({
      ...this.state,
      imageURL: this.props.imageURL
    })
  }

  @autobind
  handleInputChange({ target }) {
    this.setState({
      text: target.value
    })
  }

  render() {
    const { imageURL } = this.props

    return (
      <Modal
        show
        dialogClassName="screenshotDialog"
      >

        <Modal.Body>

          <img src={imageURL} alt="" />

          <div className="comment-wrapper">

            <label htmlFor="text">
              <FormattedMessage
                id="review-center.screenshot.modal-comment"
              />
            </label>
            <textarea
              autoFocus
              id="text"
              key="text"
              cols={100}
              rows={2}
              maxLength={1500}
              value={this.state.text}
              onChange={this.handleInputChange}
            />
          </div>

        </Modal.Body>

        <Modal.Footer>
          <GenevaButton className="small button" onClick={this.closeModal}>
            <FormattedMessage
              id="review-center.screenshot.modal-cancel"
            />
          </GenevaButton>
          <GenevaButton className="small primary button" onClick={this.confirmModal}>
            <FormattedMessage
              id="review-center.screenshot.modal-confirm"
            />
          </GenevaButton>
        </Modal.Footer>
      </Modal>)
  }
}

export default injectIntl(ScreenshotDialog)
